import { useContext } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as ArrowSelect } from 'assets/arrow-select.svg';
import i18nContext from 'components/i18n-context';
import './CurrencyPairsTableHeadRow.scss';

export const CURRENCY_PAIRS_TABLE_HEADER = [
  { label: 'from' },
  { label: 'hold' },
  { label: 'to' },
  { label: 'createDate' },
  { label: 'status' },
  { label: 'manual' },
  { label: 'actions' }
];

export const CurrencyPairsTableHeadRow = ({ handleOnSortTable, sortBy, direction }) => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {CURRENCY_PAIRS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'currency-pairs-table-head'}>
          <div className={'currency-pairs-table-head-block'}>
            <span>{i18n.getMessage(`exchangeRates.table.header.${head.label}`)}</span>
            {head.sortBy && (
              <ArrowSelect
                onClick={() => handleOnSortTable(head.sortBy)}
                className={`arrow-icon ${sortBy === head.sortBy && direction}`}
              />
            )}
          </div>
        </th>
      ))}
    </tr>
  );
};

CurrencyPairsTableHeadRow.propTypes = {
  handleOnSortTable: PropTypes.func,
  sortBy: PropTypes.string,
  direction: PropTypes.string
};
